<p-confirmDialog />

<div class="page-header">
  <div class="page-title">Gerador de Movimentações</div>
  <p-button
    label="Histórico"
    icon="pi pi-history"
    severity="secondary"
    [outlined]="true"
    type="button"
    (onClick)="goToHistory()"
  />
</div>

<p-card>
  <form [formGroup]="form" class="form-b4a" (submit)="confirmSend()">
    <!-- Tipo de movimentação -->
    <span class="p-float-label">
      <p-dropdown
        inputId="movementType"
        formControlName="movementType"
        [options]="typeOptions()"
        optionLabel="label"
        optionValue="value"
        appendTo="body"
        [style]="fullWidthStyle"
        [ngClass]="{ 'ng-invalid ng-dirty': invalidControl('movementType') }"
        (onChange)="onTypeChange()"
      />
      <label for="movementType">Tipo de movimentação *</label>
    </span>

    <!-- Produtos (vários EANs/SKUs) -->
    <div class="full-w products">
      <div class="products-header">
        <strong>Produtos</strong>
        <p-button
          label="Adicionar produto"
          icon="pi pi-plus"
          severity="secondary"
          size="small"
          type="button"
          (onClick)="addItem()"
        />
      </div>

      <div class="product-row" *ngFor="let item of itemsArray.controls; let i = index" [formGroup]="item">
        <p-dropdown
          formControlName="keyType"
          [options]="keyTypeOptions"
          optionLabel="label"
          optionValue="value"
          appendTo="body"
          styleClass="key-type"
          (onChange)="validateItem(i)"
        />
        <input
          pInputText
          type="text"
          placeholder="EAN ou SKU"
          formControlName="code"
          [ngClass]="{ 'ng-invalid ng-dirty': invalidItemCode(i) }"
          (blur)="validateItem(i)"
          (keyup.enter)="validateItem(i)"
        />
        <p-inputNumber
          formControlName="quantity"
          [min]="1"
          [showButtons]="true"
          inputStyleClass="qty"
          (onInput)="clearPreview()"
        />
        <p-button
          icon="pi pi-trash"
          severity="danger"
          [text]="true"
          type="button"
          [disabled]="!hasMultipleItems()"
          (onClick)="removeItem(i)"
        />

        <div class="gift-card full-w" *ngIf="validations()[i] as v">
          <div class="gift-card__info">
            <div class="gift-card__label">Produto</div>
            <div class="gift-card__title">
              {{ v.productVariantName || v.productVariantId }}
            </div>
            <div class="gift-card__subtitle">EAN: {{ v.internalEan }}</div>
          </div>
          <div class="gift-card__meta">
            <div *ngIf="availableStocks()[i] !== null">
              <div class="gift-card__label">Estoque {{ stockBucketLabel() }}</div>
              <div class="gift-card__value">{{ availableStocks()[i] }}</div>
            </div>
            <div>
              <div class="gift-card__label">Status</div>
              <div class="gift-card__badge" [ngClass]="v.valid ? 'ok' : 'error'">
                {{ v.valid ? 'OK' : v.validationMessage }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- E-mails -->
    <span class="p-float-label full-w">
      <textarea
        pInputTextarea
        id="emails"
        rows="4"
        formControlName="emails"
        [ngClass]="{ 'ng-invalid ng-dirty': invalidControl('emails') }"
        (input)="parseEmails()"
      ></textarea>
      <label for="emails">E-mails (um por linha ou separados por vírgula) *</label>
    </span>
    <small class="ok full-w" *ngIf="validEmails().length">
      {{ validEmails().length }} e-mail(s) com formato válido.
    </small>
    <small class="warn full-w" *ngIf="invalidEmails().length">
      {{ invalidEmails().length }} com formato inválido (serão ignorados):
      {{ invalidEmails().join(', ') }}
    </small>

    <!-- Resultado do preview -->
    <ng-container *ngIf="preview() as p">
      <small class="ok full-w" *ngIf="eligibleEmails().length">
        ✔ {{ eligibleEmails().length }} e-mail(s) encontrado(s) e apto(s).
      </small>
      <small class="error full-w" *ngIf="previewNotFound().length">
        ✖ {{ previewNotFound().length }} sem conta Glambox (confira a digitação):
        {{ previewNotFound().join(', ') }}
      </small>
      <small class="error full-w" *ngIf="!p.stockValid">✖ {{ p.stockMessage }}</small>
      <small class="ok full-w" *ngIf="p.stockValid">
        ✔ Estoque suficiente para o lote.
      </small>
    </ng-container>
    <small class="warn full-w" *ngIf="!preview() && canValidate()">
      Valide o lote antes de gerar a movimentação.
    </small>

    <div class="buttons">
      <p-button
        label="Validar lote"
        icon="pi pi-check-circle"
        severity="secondary"
        type="button"
        [disabled]="!canValidate()"
        (onClick)="validate()"
      />
      <p-button
        [label]="sendLabel()"
        icon="pi pi-send"
        type="submit"
        [disabled]="!canSubmit()"
      />
    </div>
  </form>
</p-card>
